/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'

export type Company = {
	uuid: string
	name: string
	email?: string
	phone?: string
	orgNumber?: string
	externalId?: string
	cardCount?: number
	settlementCount?: number
	createdAt: number
	updatedAt: number
}
export type CompanyWithDetails = {
	uuid: string
	name: string
	email?: string
	phone?: string
	orgNumber?: string
	externalId?: string
	cards: {
		uuid: string
		name: string
		cardNumber: string
		status: 'ACTIVE' | 'INACTIVE' | 'BLOCKED'
		customer?: {
			uuid: string
			firstName?: string
			lastName?: string
			email?: string
		}
	}[]
	recentSettlements: {
		uuid: string
		periodStart: number
		periodEnd: number
		totalAmount: CommonTypes.Amount
		settledAt?: number
	}[]
	createdAt: number
	updatedAt: number
}
export const BusinessCardStatus = {
	Active: 'ACTIVE',
	Inactive: 'INACTIVE',
	Blocked: 'BLOCKED'
} as const
export type BusinessCardStatusType = (typeof BusinessCardStatus)[keyof typeof BusinessCardStatus]
export type BusinessCard = {
	uuid: string
	name: string
	cardNumber: string
	status: BusinessCardStatusType
	company?: {
		uuid: string
		name: string
	}
	customer?: {
		uuid: string
		firstName?: string
		lastName?: string
		email?: string
	}
	createdAt: number
	updatedAt: number
	externalId?: string
}
export type Settlement = {
	uuid: string
	periodStart: number
	periodEnd: number
	totalAmount: CommonTypes.Amount
	transactionCount?: number
	settledAt?: number
	createdAt: number
}
export type BusinessCardTransaction = {
	uuid: string
	orderUuid: string
	orderDisplayId?: number
	amount: CommonTypes.Amount
	currencyCode: string
	completedAt?: number
}
export type SettlementWithTransactions = {
	uuid: string
	company: {
		uuid: string
		name: string
	}
	periodStart: number
	periodEnd: number
	totalAmount: CommonTypes.Amount
	settledAt?: number
	transactions: {
		transactionUuid: string
		orderUuid: string
		orderDisplayId?: number
		amount: CommonTypes.Amount
		currencyCode: string
		completedAt?: number
		businessCard?: {
			uuid: string
			name: string
			cardNumber: string
			employee?: {
				uuid: string
				firstName?: string
				lastName?: string
				email?: string
			}
		}
	}[]
	createdAt: number
}

export const zCompany = z.object({
	uuid: z.string(),
	name: z.string(),
	email: z.string().optional(),
	phone: z.string().optional(),
	orgNumber: z.string().optional(),
	externalId: z.string().optional(),
	cardCount: z.number().optional(),
	settlementCount: z.number().optional(),
	createdAt: z.number(),
	updatedAt: z.number()
})
export const zCompanyWithDetails = z.object({
	uuid: z.string(),
	name: z.string(),
	email: z.string().optional(),
	phone: z.string().optional(),
	orgNumber: z.string().optional(),
	externalId: z.string().optional(),
	cards: z.array(
		z.object({
			uuid: z.string(),
			name: z.string(),
			cardNumber: z.string(),
			status: z.enum(['ACTIVE', 'INACTIVE', 'BLOCKED']),
			customer: z
				.object({
					uuid: z.string(),
					firstName: z.string().optional(),
					lastName: z.string().optional(),
					email: z.string().optional()
				})
				.optional()
		})
	),
	recentSettlements: z.array(
		z.object({
			uuid: z.string(),
			periodStart: z.number(),
			periodEnd: z.number(),
			totalAmount: CommonTypes.zAmount,
			settledAt: z.number().optional()
		})
	),
	createdAt: z.number(),
	updatedAt: z.number()
})
export const zBusinessCardStatus = z.enum(['ACTIVE', 'INACTIVE', 'BLOCKED'])
export const zBusinessCard = z.object({
	uuid: z.string(),
	name: z.string(),
	cardNumber: z.string(),
	status: zBusinessCardStatus,
	company: z
		.object({
			uuid: z.string(),
			name: z.string()
		})
		.optional(),
	customer: z
		.object({
			uuid: z.string(),
			firstName: z.string().optional(),
			lastName: z.string().optional(),
			email: z.string().optional()
		})
		.optional(),
	createdAt: z.number(),
	updatedAt: z.number(),
	externalId: z.string().optional()
})
export const zSettlement = z.object({
	uuid: z.string(),
	periodStart: z.number(),
	periodEnd: z.number(),
	totalAmount: CommonTypes.zAmount,
	transactionCount: z.number().optional(),
	settledAt: z.number().optional(),
	createdAt: z.number()
})
export const zBusinessCardTransaction = z.object({
	uuid: z.string(),
	orderUuid: z.string(),
	orderDisplayId: z.number().optional(),
	amount: CommonTypes.zAmount,
	currencyCode: z.string(),
	completedAt: z.number().optional()
})
export const zSettlementWithTransactions = z.object({
	uuid: z.string(),
	company: z.object({
		uuid: z.string(),
		name: z.string()
	}),
	periodStart: z.number(),
	periodEnd: z.number(),
	totalAmount: CommonTypes.zAmount,
	settledAt: z.number().optional(),
	transactions: z.array(
		z.object({
			transactionUuid: z.string(),
			orderUuid: z.string(),
			orderDisplayId: z.number().optional(),
			amount: CommonTypes.zAmount,
			currencyCode: z.string(),
			completedAt: z.number().optional(),
			businessCard: z
				.object({
					uuid: z.string(),
					name: z.string(),
					cardNumber: z.string(),
					employee: z
						.object({
							uuid: z.string(),
							firstName: z.string().optional(),
							lastName: z.string().optional(),
							email: z.string().optional()
						})
						.optional()
				})
				.optional()
		})
	),
	createdAt: z.number()
})
